module.exports = __webpack_public_path__ + "static/img/包裝第七組組長-張子浩.3c2bf44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝第七組組長-張子浩.jpg
// module id = 6bfP
// module chunks = 1